import { createRef, useEffect, useMemo, useRef } from 'react';

export function useWindowEventListener(eventName, handler, options) {
  useEffect(() => {
    window.addEventListener(eventName, handler, options);

    return () => {
      window.removeEventListener(eventName, handler, options);
    };
  }, [eventName, handler, options]);
}

export function useEventListener(eventName, handler, options, targetRef) {
  const ref = useMemo(() => {
    return targetRef || createRef();
  }, [targetRef]);

  return useEffect(() => {
    const target = ref.current;
    if (!target) {
      return;
    }

    target.addEventListener(eventName, handler, options);

    return () => {
      target.removeEventListener(eventName, handler, options);
    };
  }, [eventName, handler, options, ref]);
}

export function useDebouncedEventListener(event, handler, target, options) {
  const debounceTimer = useRef(0);

  useEffect(() => {
    const listener = (ev) => {
      clearTimeout(debounceTimer.current);
      debounceTimer.current = setTimeout(() => {
        handler(ev);
      }, options.timeout);
    };
    target.addEventListener(event, listener, options);

    return () => {
      target.removeEventListener(event, listener, options);
      clearTimeout(debounceTimer.current);
    };
  });
}
